import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import { post } from "../../actions/general";
import { editUser } from "../../store/user/actions";

import { SeoRenderer } from "../../../common/helpers/seo";
import { IUser } from "../../store/user/models";
import { IStateTree } from "../../store/interfaces";

import loadableComponent from "./loadable";


const mapStateToProps = ({ user }: IStateTree) => ({ user: user as IUser });

export default {
    component: withRouter(connect(mapStateToProps, { post, editUser })(injectIntl(loadableComponent))),
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({ title: allMessage["menu.account"], allMessage, lang });
    },
};
